import React, { useEffect, useState } from 'react';
import './NavigationTabs.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';

const NavigationTabs = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return unsub;
  }, []);

  const currentPath = window.location.pathname;
  const currentTab = currentPath.includes('resources')
    ? 'resources'
    : currentPath.includes('playlists')
    ? 'playlists'
    : currentPath.includes('events')
    ? 'events'
    : currentPath.includes('admin')
    ? 'admin'
    : 'services';

  const linkStyle = {
    textDecoration: 'none',
  };

  return (
    <div className="nav-tabs-container">
        <div className="nav-tabs">
            <a
                href="https://www.fire-up.net/well-being/services"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'services' ? 'active' : ''}`}
            >
                Services
            </a>
            <a
                href="https://www.fire-up.net/well-being/resources"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'resources' ? 'active' : ''}`}
            >
                Resources
            </a>
            <a
                href="https://www.fire-up.net/well-being/playlists"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'playlists' ? 'active' : ''}`}
            >
                Playlists
            </a>
            <a
                href="https://www.fire-up.net/well-being/events"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'events' ? 'active' : ''}`}
            >
                Events
            </a>
            {user && (
            <a
                href="https://www.fire-up.net/well-being/admin/"
                target="_top"
                style={linkStyle}
                className={`nav-tab ${currentTab === 'admin' ? 'active' : ''}`}
            >
                Admin
            </a>
            )}
        </div>
        <button
            className="submit-button"
            onClick={() => window.open('https://1u2eip3ka2k.typeform.com/to/nWkrF76X', '_blank')}
        >
            Submit a service / resource / playlist
        </button>
    </div>
  );
};

export default NavigationTabs;
